import type { enSector } from './en-sector';

/** Turkish strings — sector campaign, victory, achievements (docs/01). */
export const trSector: Record<keyof typeof enSector, string> = {
  'sector.s1.name': 'HURDA KUŞAĞI',
  'sector.s1.tag': 'Hurda dronları eski tersaneyi koruyor',
  'sector.s2.name': 'ELEMENT ÇEKİRDEĞİ',
  'sector.s2.tag': 'Ateş, dalga, taş, fırtına ve boşluk',
  'sector.s3.name': 'KULUÇKA DERİNLİĞİ',
  'sector.s3.tag': 'Zincirler, dokunaçlar ve aç bir kraliçe',
  'sector.s4.name': 'ANOMALİ KUŞAĞI',
  'sector.s4.tag': 'Zamanın ve uzayın şaştığı yer',
  'sector.label': 'SEKTÖR {n}',
  'sector.select': 'SEKTÖR SEÇ',
  'sector.lockedHint': 'Açmak için Sektör {n} bitmeli',
  'sector.cleared': '✓ TAMAMLANDI',
  'sector.best': 'EN İYİ {time}',
  'sector.notCleared': 'HENÜZ BİTİRİLMEDİ',
  'sector.finale': 'FİNAL',
  'sector.rooms': '{n} ODA + FİNAL',
  'sector.startWeapon': 'BAŞLANGIÇ SİLAHI',
  'sector.pickSlot': 'SEKTÖR {n} — SLOT SEÇ',
  'sector.hint.keyboard': '←/→ sektör    ↑/↓ başlangıç silahı    Space oyna    Esc geri',
  'sector.hint.gamepad': '←/→ sektör    ↑/↓ başlangıç silahı    Ⓐ oyna    Ⓑ geri',
  'sector.hint.touch': 'Oynamak için bir sektöre dokun',

  'title.play': 'OYNA',
  'title.endless': 'SONSUZ',
  'title.achievements': 'BAŞARIMLAR',
  'title.pickEndless': 'SONSUZ — SLOT SEÇ',
  'title.slotSector': 'SEKTÖR {s} · ODA {room}/{total} · {cards} KART · {time}',
  'title.slotEndless': 'SONSUZ · ODA {room} · {cards} KART · {runs} DENEME · {time}',

  'hud.sectorRoom': 'S{n} · ODA {room}/{total}',
  'hud.sectorFinale': 'S{n} · FİNAL',
  'hud.achievement': 'BAŞARIM · {name}',
  'shop.sectorRoom': 'ODA {room}/{total} · {arena}',
  'shop.sectorFinale': 'FİNAL · {arena}',

  'victory.title': 'SEKTÖR TEMİZLENDİ',
  'victory.time': 'BİTİŞ SÜRESİ',
  'victory.newBest': '★ YENİ REKOR',
  'victory.unlockedSector': 'SEKTÖR {n} AÇILDI',
  'victory.unlockedEndless': 'SONSUZ MOD AÇILDI',
  'victory.campaignDone': 'KAMPANYA TAMAMLANDI',
  'victory.earned': 'KAZANILAN BAŞARIMLAR',
  'victory.noneEarned': 'Bu koşuda yeni başarım yok',
  'victory.xp': '+{n} PİLOT XP',
  'victory.next': 'SONRAKİ SEKTÖR ▶',
  'victory.replay': 'TEKRAR OYNA ▶',
  'victory.menu': 'ANA MENÜ',

  'sectorLost.where': 'SEKTÖR {n} KAYBEDİLDİ · ODA {room}/{total}',
  'sectorLost.fresh': 'Yeniden deneme sıfırdan başlar: kartlar, silahlar ve taşlar sıfırlanır.',
  'sectorLost.retry': 'SEKTÖRÜ TEKRARLA ▶',
  'runEnd.hint.keyboard': '←/→ seç    Space onay',
  'runEnd.hint.gamepad': '←/→ seç    Ⓐ onay',
  'runEnd.hint.touch': 'Bir düğmeye dokun',

  'ach.title': 'BAŞARIMLAR',
  'ach.progress': '{n}/{m} KAZANILDI',
  'ach.reward.weapon': 'Başlangıç silahı: {name}',
  'ach.reward.card': 'Dükkâna yeni kart: {name}',
  'ach.reward.endless': 'SONSUZ modu açar',
  'ach.clear_s1.name': 'KUŞAK KIRAN',
  'ach.clear_s1.desc': 'Sektör 1’i bitir — Hurda Kuşağı',
  'ach.clear_s2.name': 'ELEMENT TERBİYECİSİ',
  'ach.clear_s2.desc': 'Sektör 2’yi bitir — Element Çekirdeği',
  'ach.clear_s3.name': 'KRALİÇE AVCISI',
  'ach.clear_s3.desc': 'Sektör 3’ü bitir — Kuluçka Derinliği',
  'ach.clear_s4.name': 'ZAMAN KIRAN',
  'ach.clear_s4.desc': 'Sektör 4’ü bitir — Anomali Kuşağı',
  'ach.untouchable.name': 'DOKUNULMAZ',
  'ach.untouchable.desc': 'Bir boss’u, sahneye çıktıktan sonra hiç vurulmadan kes',
  'ach.deathless.name': 'ÖLÜMSÜZ',
  'ach.deathless.desc': 'Bir sektörü orada hiç ölmeden bitir',
  'ach.blitz.name': 'YILDIRIM',
  'ach.blitz.desc': 'Bir sektörü {m} dakikadan kısa dövüş süresinde bitir',
  'ach.arsenal.name': 'CEPHANELİK',
  'ach.arsenal.desc': 'Aynı anda {n} silahla ateş et',
  'ach.topgun.name': 'AS PİLOT',
  'ach.topgun.desc': 'Namlu kademesini {n} yap',
  'ach.collector.name': 'KOLEKSİYONCU',
  'ach.collector.desc': 'Tek koşuda {n} kart topla',
};
